<template>
  <span class="circulo2"
      :style="{backgroundImage: `url(${imagem})`}">
  </span>
</template>

<script>
export default {
  name: "PessoaImage",
  props: ["imagem"]
}
</script>

<style scoped>
/*28*/
.circulo2 {
  display: block;
  border-radius: 50%;
  height: 80px;
  width: 80px;
  background: #b1b1b1;
  background-image: url(../images/pessoa_avatar-03.png);
  background-size: cover;
  background-position: center;
  margin: 25px 20px;
}

@media (max-width : 1280px){
  .circulo2 {
    display: none;
    box-shadow: 2px 4px 17px -8px #928888ba;
  }
}

</style>